import React, { useState, useReducer, useEffect } from 'react';
import { makeStyles } from '@material-ui/core';
import ColorPicker from '../../../../shared/ui-builder/color-picker/Color-Picker';
import './Basic-Component-Text.scss';
import TextBold from './toolbar-icons/TextBold';
import TextItalic from './toolbar-icons/TextItalic';
import TextUnderline from './toolbar-icons/TextUnderline';
import TextLeft from './toolbar-icons/TextLeft';
import TextCenter from './toolbar-icons/TextCenter';
import TextRight from './toolbar-icons/TextRight';
import TextColor from './toolbar-icons/TextColor';
import CustomTextField from '../../../../shared/form-controls/custom-text-field/Custom-Text-Field';
import CustomSelect from '../../../../shared/form-controls/custom-select/Custom-Select';
import { BASIC_TEXT_COMPONENT } from '../../../../constants/UiBuilderConst';

const useStyles = makeStyles((theme) => ({
  h1: {
    fontSize: '2em !important',
    fontWeight: 'bold',
  },
  h2: {
    fontSize: '1.5em !important',
    fontWeight: 'bold',
  },
  h3: {
    fontSize: '1.17em !important',
    fontWeight: 'bold',
  },
}));

const BasicComponentText = (props) => {
  const classes = useStyles();
  const { onItemChange, config, handleError, componentNdx } = props;
  const [styleState, setStyleState] = useState({
    bold: config?.textStyle?.isBold || false,
    italic: config?.textStyle?.isItalic || false,
    underline: config?.textStyle?.isUnderlined || false,
    left: config?.textStyle?.alignment === 'LEFT' || !config?.textStyle?.alignment ? true : false,
    center: config?.textStyle?.alignment === 'CENTER' || false,
    right: config?.textStyle?.alignment === 'RIGHT' || false,
    color: false,
  });
  const [color, setColor] = useState(config.textStyle?.color ? config.textStyle?.color : '#000000');
  const [showColorPicker, setShowColorPicker] = useState(false);

  const [formData, setFormData] = useReducer((state, newState) => ({ ...state, ...newState }), {
    paddingTop: {
      value: '',
      fieldName: 'Padding Top',
      errors: {},
      validations: ['oneToFive'],
    },
    paddingBottom: {
      value: '',
      fieldName: 'Padding Bottom',
      errors: {},
      validations: ['oneToFive'],
    },
    textType: {
      value: '',
      fieldName: 'Text Type',
      errors: {},
      validations: ['required'],
    },
    inputText: {
      value: '',
      fieldName: 'Input Text',
      errors: {},
      validations: ['required'],
    },
  });

  useEffect(() => {
    if (config) {
      const currFields = { ...formData };
      currFields.inputText.value = config?.text;
      currFields.textType.value = config?.textType;
      currFields.paddingTop.value = config?.textPadding?.paddingTop || 0;
      currFields.paddingBottom.value = config?.textPadding?.paddingBottom || 0;
      setFormData(currFields);
    }
  }, []);

  useEffect(() => {
    let alignment;
    if (styleState.right) {
      alignment = 'RIGHT';
    } else if (styleState.center) {
      alignment = 'CENTER';
    } else {
      alignment = 'LEFT';
    }
    onItemChange({
      componentName: BASIC_TEXT_COMPONENT,
      config: {
        text: formData.inputText.value,
        textType: formData.textType.value,
        textPadding: {
          paddingTop: parseInt(formData.paddingTop.value) || 0,
          paddingBottom: parseInt(formData.paddingBottom.value) || 0,
        },
        textStyle: {
          isBold: styleState.bold,
          isItalic: styleState.italic,
          isUnderlined: styleState.underline,
          alignment: alignment,
          color: color,
        },
      },
    });
  }, [formData, styleState, color]);

  useEffect(() => {
    if (handleError && handleError.length > 0) {
      const currError = handleError.find(
        (getError) => getError.pos === componentNdx && getError.id === BASIC_TEXT_COMPONENT,
      );
      const currFields = { ...formData };
      currFields.inputText.errors = {};
      currFields.textType.errors = {};
      currFields.paddingBottom.errors = {};
      currFields.paddingTop.errors = {};
      if (currError?.config?.text === 'required') {
        currFields.inputText.errors = { required: 'Input Text is required' };
      }

      if (currError?.config?.textType === 'required') {
        currFields.textType.errors = { required: 'Text Type is required' };
      }
      if (currError?.config?.paddingBottom === 'oneToFive') {
        currFields.paddingBottom.errors = {
          oneToFive: 'Padding value should range from 1 to 5',
        };
      }

      if (currError?.config.paddingTop === 'oneToFive') {
        currFields.paddingTop.errors = {
          oneToFive: 'Padding value should range from 1 to 5',
        };
      }

      setFormData(currFields);
    }
  }, [handleError]);

  useEffect(() => {
    let temp = { ...styleState };
    temp['color'] = showColorPicker;
    setStyleState(temp);
  }, [showColorPicker]);

  const onClickIcon = (type) => {
    let temp = { ...styleState };
    if (type === 'left' || type === 'right' || type === 'center') {
      temp['right'] = false;
      temp['left'] = false;
      temp['center'] = false;
    }
    if (type !== 'color') {
      temp[type] = !styleState[type];
    }
    if (type === 'color') {
      setShowColorPicker(!showColorPicker);
    }
    setStyleState(temp);
  };

  const onColorChange = (color) => {
    setColor(color);
  };

  return (
    <>
      <div className='row my-2 mx-4'>
        <div className='col-md-12 d-flex justify-content-between pb-2 pt-4'>
          <TextBold
            color={!styleState.bold ? '#828282' : '#29e67c'}
            onClick={() => onClickIcon('bold')}
          />
          <TextItalic
            color={!styleState.italic ? '#828282' : '#29e67c'}
            onClick={() => onClickIcon('italic')}
          />
          <TextUnderline
            color={!styleState.underline ? '#828282' : '#29e67c'}
            onClick={() => onClickIcon('underline')}
          />
          <div className='text-toolbar-divider' />
          <TextLeft
            color={!styleState.left ? '#828282' : '#29e67c'}
            onClick={() => onClickIcon('left')}
          />
          <TextCenter
            color={!styleState.center ? '#828282' : '#29e67c'}
            onClick={() => onClickIcon('center')}
          />
          <TextRight
            color={!styleState.right ? '#828282' : '#29e67c'}
            onClick={() => onClickIcon('right')}
          />
          <div className='text-toolbar-divider' />
          <TextColor
            color={!styleState.color ? '#828282' : '#29e67c'}
            pickerColor={color}
            onClick={() => onClickIcon('color')}
          />
        </div>
        <div className='row mt-4 mb-3'>
          <div className='col-md-6 mb-3'>
            <CustomTextField
              item={formData.paddingTop}
              handleInputChange={(e) => {
                setFormData({ paddingTop: e });
              }}
              type='number'
              max={5}
            />
          </div>
          <div className='col-md-6 mb-3'>
            <CustomTextField
              item={formData.paddingBottom}
              handleInputChange={(e) => {
                setFormData({ paddingBottom: e });
              }}
              type='number'
              max={5}
            />
          </div>
          <div className='col-md-12 mb-3'>
            <CustomSelect
              item={formData.textType}
              handleInputChange={(e) => {
                setFormData({ textType: e });
              }}
              labelField='name'
              valueField='id'
              options={[
                {
                  name: 'H1- Headline',
                  id: 'HEADLINE',
                  styleVal: classes.h1,
                },
                {
                  name: 'H2- Subtext',
                  id: 'SUBTEXT',
                  styleVal: classes.h2,
                },
                {
                  name: 'H3- Body',
                  id: 'BODY',
                  styleVal: classes.h3,
                },
              ]}
              hideNullOption={true}
              customStyle={true}
            />

            <div className='col-md-12 mt-4 mb-3'>
              <CustomTextField
                item={formData.inputText}
                handleInputChange={(e) => {
                  setFormData({ inputText: e });
                }}
                maxLength={1000}
                multiline={true}
                rows={5}
                endAdornment={true}
                characterCount={true}
              />
            </div>
          </div>
        </div>
      </div>
      {showColorPicker && (
        <ColorPicker
          backgroundColor={color}
          onColorChange={onColorChange}
          showColorPicker={showColorPicker}
          setShowColorPicker={setShowColorPicker}
        />
      )}
    </>
  );
};

export default BasicComponentText;
